import { X as y, ErrorCircle as T } from "@styled-icons/boxicons-regular";
import o from "classnames";
import { useFormContext as _ } from "react-hook-form";
import M from "next/dynamic";
import { formInputElement as f, inputLabel as b, inputContainer as v, inputIsInvalid as N, inputTag as E, asteriskContainer as g, inputErrorMessage as q, clearButton as S } from "./FormInputElement.css.js";
import { MultiSelectionElement as w } from "./MultiSelectionElement.js";
import { SelectionElement as Z } from "./SelectionElement.js";
import { jsx as i, jsxs as s } from "react/jsx-runtime";
const n = M(() => import("@hookform/error-message").then((r) => r.ErrorMessage), {
  ssr: !1
});
function A() {
  return /* @__PURE__ */ i(T, {
    size: 24
  });
}
function D({
  element: r,
  attributes: e,
  className: d,
  children: c
}) {
  var p, h;
  const t = `input-${r.id}`, {
    register: u,
    formState: x,
    watch: C,
    resetField: F
  } = _() || {}, {
    errors: a,
    touchedFields: m
  } = x || {}, I = C(r.name);
  switch (r.inputType) {
    case "email":
    case "text":
      return /* @__PURE__ */ s("div", {
        ...r.customAttributes,
        ...e,
        className: o(d, f, (p = r.customAttributes) == null ? void 0 : p.className),
        children: [!r.is_label_hidden && /* @__PURE__ */ i("label", {
          htmlFor: t,
          className: b,
          contentEditable: !1,
          children: r.label
        }), /* @__PURE__ */ s("div", {
          children: [/* @__PURE__ */ s("div", {
            className: o(v, {
              [N]: m[r.name] && !!a[r.name]
            }),
            children: [/* @__PURE__ */ i("input", {
              type: "text",
              className: E,
              disabled: r.disabled,
              placeholder: r.placeholder,
              ...u(r.name, {
                required: r.required ? "This field is required" : !1,
                pattern: r.inputType === "email" ? {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Invalid email address"
                } : void 0
              })
            }), I && !a[r.name] && /* @__PURE__ */ i(y, {
              className: S,
              onClick: () => {
                F(r.name);
              },
              size: 24
            }), r.required && /* @__PURE__ */ i("div", {
              className: g,
              children: /* @__PURE__ */ i("span", {
                children: "*"
              })
            }), /* @__PURE__ */ i(n, {
              name: r.name,
              render: A
            })]
          }), /* @__PURE__ */ i(n, {
            errors: a,
            name: r.name,
            render: (l) => /* @__PURE__ */ i("div", {
              className: q,
              children: l.message
            })
          })]
        }), c]
      });
    case "number":
      return /* @__PURE__ */ s("div", {
        ...r.customAttributes,
        ...e,
        className: o(d, f, (h = r.customAttributes) == null ? void 0 : h.className),
        children: [!r.is_label_hidden && /* @__PURE__ */ i("label", {
          htmlFor: t,
          className: b,
          contentEditable: !1,
          children: r.label
        }), /* @__PURE__ */ s("div", {
          children: [/* @__PURE__ */ s("div", {
            className: o(v, {
              [N]: m[r.name] && !!a[r.name]
            }),
            children: [/* @__PURE__ */ i("input", {
              type: "number",
              className: E,
              disabled: r.disabled,
              placeholder: r.placeholder,
              ...u(r.name, {
                required: r.required ? "This field is required" : !1
              })
            }), r.required && /* @__PURE__ */ i("div", {
              className: g,
              children: /* @__PURE__ */ i("span", {
                children: "*"
              })
            }), /* @__PURE__ */ i(n, {
              errors: a,
              name: r.name,
              render: A
            })]
          }), /* @__PURE__ */ i(n, {
            errors: a,
            name: r.name,
            render: (l) => /* @__PURE__ */ i("div", {
              className: q,
              children: l.message
            })
          })]
        }), c]
      });
    case "multiselection":
      return /* @__PURE__ */ i(w, {
        element: r,
        attributes: e,
        className: d,
        children: c
      });
    case "selection":
      return /* @__PURE__ */ i(
        Z,
        {
          element: r,
          attributes: e,
          className: d,
          children: c
        }
      );
    default:
      return /* @__PURE__ */ i("div", {});
  }
}
export {
  D as FormInputElement
};
